import * as Sentry from "@sentry/vue";
import type { App, Plugin } from "vue";

const appVersion = APP_VERSION ?? "dev";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export interface SentryPluginOptions {}

export const sentry: Plugin = {
  install(app: App) {
    if (!SENTRY_DSN) {
      console.warn("Sentry DSN not configured, error tracking disabled");
      return;
    }

    Sentry.init({
      app,
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,
      release: `hoofvision@${appVersion}`,
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event) {
        if (import.meta.env.DEV) {
          console.log("[Sentry] Would send event:", event);
          return null;
        }
        return event;
      },
    });
  },
};

export function setSentryUser(userId: string, email?: string) {
  Sentry.setUser({ id: userId, email });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
